let checkoutPromise;

export function loadRazorpayCheckout() {
  if (window.Razorpay) {
    return Promise.resolve(true);
  }
  if (checkoutPromise) {
    return checkoutPromise;
  }
  checkoutPromise = new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = () => {
      checkoutPromise = undefined;
      resolve(false);
    };
    document.body.appendChild(script);
  });
  return checkoutPromise;
}